// Stores
import { useUiStore } from '@stores/ui';

// Personal libs
import { tailleFichier } from '@shared/lib/tools.lib';
import {
  checkEmail,
  checkPassword,
  checkUsername,
} from '@shared/lib/security.lib';
import { $t } from '@i18n/utils';
import { ValidationRule } from 'quasar';

export const usernameExample = () => $t('form.username.example.content');
export const emailExample = () => $t('form.email.example.content');
export const passwordExample = () => $t('form.password.example.content');
export const secretCodeExample = () => $t('form.secretCode.example.content');
export const messageExample = () => $t('form.textarea.example.content');

/**
 * **************************************************
 * MESSAGES
 * **************************************************
 */
export const usernameErrorMessage = () => {
  const uiStore = useUiStore();
  return $t('form.username.error', {
    usernameMin: uiStore?.config?.security?.username?.min ?? 3,
    usernameMax: uiStore?.config?.security?.username?.max ?? 64,
    usernameExample: usernameExample()
  });
};

export const emailErrorMessage = () => $t('form.email.error', {emailExample: emailExample()});

export const passwordErrorMessage = () => $t('form.password.error', {passwordExample: passwordExample()});
export const secretCodeErrorMessage = () => $t('form.secretCode.error', {secretCodeExample: secretCodeExample()});

export const messageErrorMessage = () => {
  const uiStore = useUiStore();
  return $t('form.textarea.error', {
    messageMin: uiStore.config?.security?.message?.min ?? 6,
    messageExample: messageExample()
  })
};

export const subjectErrorMessage = () => $t('form.subject.error');

export const requiredErrorMessage = () => $t('form.requiredErrorMessage');

export const requiredSelectAtLeastOneDemonstratorMessage = () =>
  'Merci de saisir au moins un élément dans la liste des pratiquants';

export const videoFileErrorMessage = () => {
  const uiStore = useUiStore();
  return `Choisir une vidéo au format MP4 et de moins de ${tailleFichier(
    uiStore.config?.uploader?.maxFileSize ?? 0,
  )}`;
};

export const checkboxErrorMessage = () => $t('signup.cgu.error')

/**
 * **************************************************
 * CHECKERS
 * **************************************************
 */

export const usernameRules: ValidationRule[] = [
  (val) => (val && checkUsername(val)) || usernameErrorMessage(),
];

export const emailRules: ValidationRule[] = [
  (val) => (val && checkEmail(val)) || emailErrorMessage(),
];

export const passwordRules: ValidationRule[] = [
  (val) => {
    const uiStore = useUiStore();

    return (
      (val && checkPassword(val, uiStore.config?.security)) ||
      passwordErrorMessage()
    );
  },
];

export const messageRules: ValidationRule[] = [
  (val) => {
    const uiStore = useUiStore();

    return (
      (val && val.length >= (uiStore.config?.security?.message?.min ?? 6)) ||
      messageErrorMessage()
    );
  },
];

export const subjectRules: ValidationRule[] = [
  (val) => (val !== null && val != '') || subjectErrorMessage(),
];

export const videoFileRules: ValidationRule[] = [
  (val) => (val != null && !Array.isArray(val)) || videoFileErrorMessage(),
];

export const requiredRules: ValidationRule[] = [
  (val) => (val && val.length > 0) || requiredErrorMessage(),
];

export const requiredAtLeastOneDemonstrator: ValidationRule[] = [
  (val) => (val != null) || requiredSelectAtLeastOneDemonstratorMessage(),
];

export const checkboxRules: ValidationRule[] = [
  (val) => !val || checkboxErrorMessage(),
];